import { useReducer, useMemo } from 'react';

type Params = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc' | undefined;
  page: number;
  limit: number;
  search?: string;
};

const getInitialParams = (): Params => {

  return {
    sortBy:"createdAt",
    sortOrder: "desc",
    page: 1,
    limit: 10,
    search: undefined,
  };
};


type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_FILTERS'; payload: Partial<Params>; resetPage?: boolean }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload};
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };

      case 'SET_FILTERS':
      return {
        ...state,
        ...Object.fromEntries(
          Object.entries(action.payload).map(([key, val]) => [key, val === '' ? undefined : val])
        ),
      };
    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}

export function useManageCustomer() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
  ]);

  return { params: stableParams, dispatch };
}
